import request from '@/plugin/axios'
export function getCardPagedList(query) {
    return request({
        url: '/moblieapp/cardPagedlist',
        method: 'post',
        params: query
    })
}
